import { useOrientationStore } from '@/stores/orientation.store'
import RecommendationCard from './RecommendationCard'

interface Props {
  onConfirm: (structureId: string) => void
  isConfirming: boolean
}

export default function OrientationResults({ onConfirm, isConfirming }: Props) {
  const { result } = useOrientationStore()

  if (!result) return null

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold text-neutral-900">Recommandations</h3>
          <p className="text-sm text-neutral-500">
            Profil: <span className="font-medium text-primary-600">{result.profileName}</span>
            {' -- '}Ref: <span className="font-mono text-xs">{result.orientationRef}</span>
          </p>
        </div>
        <span className="px-3 py-1 bg-primary-50 text-primary-700 rounded-full text-xs font-medium">
          {result.recommendations.length} structure{result.recommendations.length > 1 ? 's' : ''}
        </span>
      </div>

      {/* Emergency call */}
      <div className="bg-red-50 border border-red-200 rounded-lg p-3 flex items-center justify-between">
        <span className="text-sm text-red-800">Urgence? Appelez le</span>
        <a href="tel:1515" className="bg-red-600 text-white px-4 py-1.5 rounded-lg text-sm font-bold hover:bg-red-700">
          1515
        </a>
      </div>

      {/* Cards */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {result.recommendations.map((rec) => (
          <RecommendationCard
            key={rec.structureId}
            recommendation={rec}
            onChoose={onConfirm}
            isConfirming={isConfirming}
          />
        ))}
      </div>

      {result.recommendations.length === 0 && (
        <div className="text-center py-8 text-neutral-500">
          <p className="text-lg">Aucune structure disponible</p>
          <p className="text-sm mt-1">Veuillez contacter le 1515 pour une assistance d'urgence</p>
        </div>
      )}
    </div>
  )
}
